import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import "@freyr/freya-design-system/dist/src/css/freyads.min.css";
import './assets/scss/main.scss';
import { LicenseInfo } from "@mui/x-license-pro";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { FreyrLibraryProvider } from "@freyr/freyr-react-common";
import { token } from './Services/apiheader';
import { SnackbarProvider } from 'notistack';
import { CookiesProvider } from 'react-cookie';
const licenseKey=process.env.REACT_APP_MUI_LICENSE_KEY;
LicenseInfo.setLicenseKey(licenseKey ?? "");
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const queryClient = new QueryClient();
root.render(
  <CookiesProvider>
    <QueryClientProvider client={queryClient}>
      <FreyrLibraryProvider token={token}>
        <React.Suspense fallback={null}>
          <SnackbarProvider
      maxSnack={1}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
          <App />
          </SnackbarProvider>
        </React.Suspense>
      </FreyrLibraryProvider>
    </QueryClientProvider>
  </CookiesProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
